import React from "react";
import { typePlaceService } from "../jwt/_services/hotel/typePlaceService";

export const typePlaceProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const listItems = await typePlaceService.getList();
        return listItems.map((itemData) => {
            const {id, code, title:name} = itemData
            return (
                {
                    id: id,
                    value: code + " - " + name,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        this.setState({error: error.message});
    }
}

async function getItem(id) {
    try {
        const item = await typePlaceService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        this.setState({error: error.message});
    }
}